export function buildEntityHref(workspaceUrl: string, entityType: string, entityId: string): string {
  const base = `/${workspaceUrl}`;
  switch (entityType) {
    case "CLIMATE_ACTION":
      return `${base}/climate-actions/${entityId}`;
    case "INDICATOR":
      return `${base}/indicators/${entityId}`;
    default:
      return `${base}/projects/${entityId}`;
  }
}
